export default __webpack_public_path__ + "assets/dashboard.d9ad65f1.svg";